<template>
  <pt-obs-department-question class="pt-obs-department-question__withData" :allCitys="allCitys" :allMembers="allMembers"></pt-obs-department-question>
</template>

<script>
import PtObsDepartmentQuestion from './index'
export default {
  name: 'pt-obs-department-question__withData',
  components: {
    'pt-obs-department-question': PtObsDepartmentQuestion
  },
  data () {
    return {
      allCitys: [],
      allMembers: []
    }
  },
  methods: {
    getAllCity () {
      this.$store.dispatch('getAllCity').then(res => {
        this.allCitys = res
      }).catch(err => {
        this.$message.error(err || '获取地区列表失败')
      })
    },
    // 获取全部会员等级列表
    getAllMembers () {
      this.loading = true
      this.$store.dispatch('getAllMembers').then(res => {
        this.loading = false
        this.allMembers = res.data
        this.allMembers.forEach(item => {
          item.code = item.code + ''
        })
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取会员等级失败')
      })
    }
  },
  created () {
    this.getAllCity()
    this.getAllMembers()
  }
}
</script>
